// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.building-management {
  padding: 20px;
}

.building-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #eee;
}

.building-header h3 {
  margin: 0;
  color: #333;
  font-size: 24px;
}

.building-report-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
  color: #666;
  font-size: 13px;
}

.report-summary-pill {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #e8f2ff;
  color: #0b5cad;
  font-weight: 600;
}

.add-building-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.add-building-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 260px;
  font-size: 14px;
}

.add-building-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.add-building-btn:hover {
  background-color: #0056b3;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #f5c6cb;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #c3e6cb;
}

.no-buildings {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.no-buildings p {
  font-size: 18px;
  margin-bottom: 20px;
}

.buildings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.building-card {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  cursor: pointer;
  width: 100%;
}

.building-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.building-thumb {
  width: 100%;
  height: 180px;
  border-radius: 6px;
  overflow: hidden;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.building-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail-placeholder {
  width: 100%;
  height: 180px;
  border-radius: 6px;
  background: linear-gradient(135deg, #fafafa, #f0f0f0);
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  font-size: 14px;
}

.building-info h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.building-description {
  color: #666;
  margin: 8px 0;
  line-height: 1.4;
}

.building-address {
  color: #555;
  margin: 8px 0;
  font-size: 14px;
}

.building-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
  padding-top: 15px;
  border-top: 1px solid #eee;
  font-size: 13px;
  color: #666;
  gap: 12px;
}

.floors-count {
  font-weight: 500;
}

.created-date {
  font-size: 12px;
}

.building-report-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #eee;
  font-size: 13px;
  color: #555;
}

.report-status-chip {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.report-status-chip.generated {
  background: #e8f7ee;
  color: #1d7b43;
}

.report-status-chip.pending {
  background: #fff4df;
  color: #9a5a00;
}

.report-count,
.latest-report-date {
  white-space: nowrap;
}

.building-actions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.edit-btn,
.delete-btn {
  flex: 1 1 150px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.edit-btn {
  background-color: #28a745;
  color: white;
}

.edit-btn:hover {
  background-color: #218838;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
}

.delete-btn:hover {
  background-color: #c82333;
}

/* Delete confirmation modal */
.delete-modal {
  width: 400px;
  max-width: 90vw;
  padding: 20px;
  text-align: center;
}

.delete-modal h3 {
  margin: 0 0 15px 0;
  color: #dc3545;
}

.delete-modal p {
  margin-bottom: 25px;
  color: #666;
  line-height: 1.5;
}

.delete-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.delete-button:hover {
  background-color: #c82333;
}

/* Responsive design */
@media (max-width: 768px) {
  .building-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .buildings-grid {
    grid-template-columns: 1fr;
  }
  
  .building-details {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BuildingManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,qDAAqD;EACrD,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF","sourcesContent":[".building-management {\n  padding: 20px;\n}\n\n.building-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #eee;\n}\n\n.building-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 24px;\n}\n\n.building-report-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-top: 8px;\n  color: #666;\n  font-size: 13px;\n}\n\n.report-summary-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #e8f2ff;\n  color: #0b5cad;\n  font-weight: 600;\n}\n\n.add-building-controls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.add-building-input {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  width: 260px;\n  font-size: 14px;\n}\n\n.add-building-btn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.add-building-btn:hover {\n  background-color: #0056b3;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border: 1px solid #f5c6cb;\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border: 1px solid #c3e6cb;\n}\n\n.no-buildings {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n}\n\n.no-buildings p {\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n.buildings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.building-card {\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n  cursor: pointer;\n  width: 100%;\n}\n\n.building-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n.building-thumb {\n  width: 100%;\n  height: 180px;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #f2f2f2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.building-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.thumbnail-placeholder {\n  width: 100%;\n  height: 180px;\n  border-radius: 6px;\n  background: linear-gradient(135deg, #fafafa, #f0f0f0);\n  color: #999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.building-info h4 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.building-description {\n  color: #666;\n  margin: 8px 0;\n  line-height: 1.4;\n}\n\n.building-address {\n  color: #555;\n  margin: 8px 0;\n  font-size: 14px;\n}\n\n.building-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 15px 0;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n  font-size: 13px;\n  color: #666;\n  gap: 12px;\n}\n\n.floors-count {\n  font-weight: 500;\n}\n\n.created-date {\n  font-size: 12px;\n}\n\n.building-report-status {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #eee;\n  font-size: 13px;\n  color: #555;\n}\n\n.report-status-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.report-status-chip.generated {\n  background: #e8f7ee;\n  color: #1d7b43;\n}\n\n.report-status-chip.pending {\n  background: #fff4df;\n  color: #9a5a00;\n}\n\n.report-count,\n.latest-report-date {\n  white-space: nowrap;\n}\n\n.building-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n.edit-btn,\n.delete-btn {\n  flex: 1 1 150px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.edit-btn {\n  background-color: #28a745;\n  color: white;\n}\n\n.edit-btn:hover {\n  background-color: #218838;\n}\n\n.delete-btn {\n  background-color: #dc3545;\n  color: white;\n}\n\n.delete-btn:hover {\n  background-color: #c82333;\n}\n\n/* Delete confirmation modal */\n.delete-modal {\n  width: 400px;\n  max-width: 90vw;\n  padding: 20px;\n  text-align: center;\n}\n\n.delete-modal h3 {\n  margin: 0 0 15px 0;\n  color: #dc3545;\n}\n\n.delete-modal p {\n  margin-bottom: 25px;\n  color: #666;\n  line-height: 1.5;\n}\n\n.delete-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.delete-button:hover {\n  background-color: #c82333;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .building-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .buildings-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .building-details {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
